module.exports = __webpack_public_path__ + "img/our-story.e6f2b615.webp";